(function (scope) {
	'use strict';

	var CookieAlert = function (elementsOrSelector) {

		if (typeof elementsOrSelector === 'string') {
			this.$elements = $(elementsOrSelector);
		} else if (elementsOrSelector !== undefined) {
			this.$elements = elementsOrSelector;
    }

		if (this.$elements.length) {
			this.initialize();
		} else {
			console.warn('CookieAlert selector doesn\'t match any elements.');
		}
	};

	CookieAlert.prototype.initialize = function () {
		this.addEventHandlers();
    if (!this.getCookie('cookieAccept')) {
      this.$elements.show();
    }
	};

	CookieAlert.prototype.addEventHandlers = function () {
		this.handleClick = this.onClick.bind(this);
    this.$elements.find('.js-cookie-alert-close').on('click touchdown', this.handleClick);
	};

	CookieAlert.prototype.onClick = function (event) {
    this.setCookie('cookieAccept', 1, 30);
    this.$elements.addClass('is-hidden');
	};

  CookieAlert.prototype.setCookie = function(cookieName, cookieValue, nDays) {
    var today = new Date(),
      expire = new Date();

    if (nDays === null || nDays === 0) {
      nDays = 1;
    }

    expire.setTime(today.getTime() + 3600000 * 24 * nDays);
    document.cookie = cookieName + '=' + escape(cookieValue) + ';expires=' + expire.toGMTString() + '; path=/';
  };

  CookieAlert.prototype.getCookie = function(cookieName) {
    var theCookie = ' ' + document.cookie,
      index = theCookie.indexOf(' ' + cookieName + '=');

    if (index === -1) {
      index = theCookie.indexOf(';' + cookieName + '=');
    }

    if (index === -1 || cookieName === '') {
      return '';
    }

    var index1 = theCookie.indexOf(';', index + 1);
    if (index1 === -1) {
      index1 = theCookie.length;
    }

    return unescape(theCookie.substring(index + cookieName.length + 2, index1));
  };

  CookieAlert.prototype.unsetCookie = function(cookieName) {
    document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
  };

	scope.CookieAlert = CookieAlert;
})(window.Roots || (window.Roots = {}));
